import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Popconfirm } from 'antd';

import ErrorBoundary from '../../errorboundary';
import SelectItem from '../selectitem';
import InputItem from '../inputitem';

import { IconDelete } from '../../../data/assets/icons';

const ResetParameterForm = (props) => {
    const { title, title_class, container_class, delete_container_class, delete_popconfirm_class, reset_parameters, variables, onChangeParameterKey, onChangeParameterValue, onClickDeleteResetParameterItem, onClickAddResetParameter, add_button_text } = props;

    return (
        <div className={container_class}>
            <div className="ori-r-pad-30">
                {
                    title &&
                    <p className={`ori-t-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
                }
                {
                    reset_parameters && reset_parameters.map((parameter, index) => {
                        return (
                            <ErrorBoundary key={index}>
                                <Row gutter={8} className="ori-relative ori-animated ori-zoom-in">
                                    <Col xs={24} sm={12}>
                                        <SelectItem show_search dropdown_class={delete_popconfirm_class} placeholder="Select key" options={variables} value={parameter.key} onChange={(value) => onChangeParameterKey(value, index)} />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <InputItem placeholder="Enter Value" value={parameter.value} onChange={(e) => onChangeParameterValue(e.target.value, index)} />
                                    </Col>
                                    <div className={`ori-absolute ${delete_container_class}`}>
                                        <Popconfirm overlayClassName="ori-zindex-99999" placement="topRight" title="Are you sure?" okText="Yes" cancelText="No" onConfirm={() => { onClickDeleteResetParameterItem(index); }} >
                                            <div className="ori-pad-3">
                                                <IconDelete size={18} className="ori-font-light-hover-primary ori-cursor-ptr" />
                                            </div>
                                        </Popconfirm>
                                    </div>
                                </Row>
                            </ErrorBoundary>
                        );
                    })
                }
            </div>
            <Button type="dashed" className="ori-full-width ori-tb-mrgn-5" onClick={onClickAddResetParameter} >{add_button_text}</Button>
        </div>
    );
};

ResetParameterForm.propTypes = {
    title: PropTypes.string,
    title_class: PropTypes.string,
    delete_popconfirm_class: PropTypes.string,
    container_class: PropTypes.string,
    delete_container_class: PropTypes.string,
    reset_parameters: PropTypes.array,
    variables: PropTypes.array,
    onClickDeleteResetParameterItem: PropTypes.func,
    onClickAddResetParameter: PropTypes.func,
    onChangeParameterKey: PropTypes.func,
    onChangeParameterValue: PropTypes.func,
    add_button_text: PropTypes.string,
};

ResetParameterForm.defaultProps = {
    conatiner_class: "ori-tb-pad-5",
    delete_container_class: "ori-align-left-full ori-align-top-6",
    reset_parameters: [],
    variables: [],
    add_button_text: "Add Reset Parameter"
};

export default ResetParameterForm;



// WEBPACK FOOTER //
// ./src/components/form/resetparameterform/index.js